import { WizardGroupEnum } from "../enums/wizard-group-enum";

/**
 * Built-in per-language default titles for the 5 standard wizard nav groups,
 * keyed by WizardGroupEnum id. Consulted as tier 2 when a server-loaded flow
 * config has a literal English title in the base slot and no _i18n sidecar.
 *
 * EN is intentionally omitted — EN always falls through to the base `title` so
 * tenant-customized English titles (e.g. "My Application Info") are preserved.
 */
export const NAV_GROUP_LABEL_DEFAULTS: Partial<Record<WizardGroupEnum, Record<string, { title: string }>>> = {
  [WizardGroupEnum.MyInfo]: {
    es: { title: "Mi información" },
  },
  [WizardGroupEnum.MyFinances]: {
    es: { title: "Mis finanzas" },
  },
  [WizardGroupEnum.PropertyAndLoan]: {
    es: { title: "Propiedad y préstamo" },
  },
  [WizardGroupEnum.Declarations]: {
    es: { title: "Declaraciones" },
  },
  [WizardGroupEnum.ReviewAndSubmit]: {
    es: { title: "Revisar y enviar" },
  },
};
